import unimed from '/public/images/partners/unimed.webp'
import wellhub from '/public/images/partners/wellhub.webp'
import reebok from '/public/images/partners/reebok.webp'
import integralMedica from '/public/images/partners/integral-medica.webp'

export const PARTNERS = [
  { url: reebok, title: 'Reebok', width: 178, height: 90, className: 'reebok' },
  {
    url: unimed,
    title: 'Unimed',
    width: 180,
    height: 90,
    className: 'unimed'
  },
  {
    url: wellhub,
    title: 'Wellbok',
    width: 93,
    height: 90,
    className: 'wellHub'
  },
  {
    url: integralMedica,
    title: 'Integral Médica',
    width: 189,
    height: 90,
    className: 'integralMedica'
  }
]
